import React from "react";
import { useParams } from "react-router";
import star from "../images/star.svg";
import DataArray from "../DataArray";
import "../styles/ItemDetails.css";
import { useStateValue } from "../StateProvider";
import { useHistory } from "react-router-dom";

import { GlassMagnifier } from "react-image-magnifiers";
function ItemDetails() {
  const history = useHistory();
  const { id } = useParams();
  const items = DataArray();

  const [{ basket }, dispatch] = useStateValue();
  const addToBasket = () => {
    dispatch({
      type: "ADD_TO_BASKET",
      item: {
        id: singleItem.id,
        title: singleItem.title,
        image: singleItem.image,
        price: singleItem.price,
        rating: singleItem.rating,
      },
    });
  };

  if (items.length) {
    console.log("from details", items);
    console.log(id);
  }

  const singleItem = items.find((item) => item.id == id);

  return (
    <div className="item__details">
      <div className="item__image">
        <GlassMagnifier
          imageSrc={singleItem.image}
          magnifierSize="50%"
          allowOverflow={true}
          previewSizePercentage="50"
          square
          className="image"
          magnifierOffsetY={-50}
        />
      </div>

      <div className="item__info">
        <strong> ${singleItem.price}</strong>
        <h4>{singleItem.title}</h4>

        <div className="product__rating">
          {Array(singleItem.rating).fill(<img src={star} alt="" width="20" />)}
        </div>
      </div>
      <div className="item__control">
        <button onClick={addToBasket}>Add to Basket</button>
        <button onClick={() => history.replace("/")}>Continue Shoping</button>
      </div>
    </div>
  );
}

export default ItemDetails;
